class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.endDate = new Date(this.getAttribute('data-end-date')).getTime();
    if (isNaN(this.endDate)) return;

    this.replacementText = this.getAttribute('data-replacement-text') || '';
    this.textElement = this.querySelector('[data-countdown-text]');
    this.countdownElement = this.querySelector('[data-countdown]');

    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate - now;

    if (distance < 0) {
      clearInterval(this.interval);
      if (this.textElement && this.replacementText) {
        this.textElement.innerHTML = this.replacementText;
      }
      if (this.countdownElement) {
        this.countdownElement.textContent = '';
      }
      return;
    }

    const hours = Math.floor(distance / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (this.countdownElement) {
      const h = String(hours).padStart(2, '0');
      const m = String(minutes).padStart(2, '0');
      const s = String(seconds).padStart(2, '0');
      this.countdownElement.textContent = `${h}H ${m}M ${s}S`;
    }
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);
